import React from "react";
import slideMini from "assets/images/landingAir/newyear/slide-mini-lg.jpg";
import slideMiniWebp from "assets/images/landingAir/newyear/slide-mini-lg.webp";
import slideMiniSm from "assets/images/landingAir/newyear/slide-mini-sm.jpg";
import slideMiniWebpSm from "assets/images/landingAir/newyear/slide-mini-sm.jpg?as=webp";
import ImageLoader from "../../common/ImageLoader";

function AirMiniSlide({ isMobile }) {
  return (
    <div className="hero-refresh__item hero-item hero-item--mini">
      <p className="hero-item__ribbon">
        <strong>Back in Stock</strong> <strong>Back in Stock</strong>{" "}
        <strong>Back in Stock</strong>
      </p>
      <p className="hero-item__badge-alt">
        {isMobile ? (
          <>
            “Best Smart Air Purifier”
            <br /> – HGTV Clean Home Awards
          </>
        ) : (
          <>
            <strong>“Best Smart Air Purifier”</strong>
            <br />
            <span> HGTV Clean Home Awards</span>
          </>
        )}
      </p>
      <div className="hero-item__content">
        <h2 className="hero-item__title">
          Your Mini & Mighty Summer Starts Here.
        </h2>
        <a
          href="https://buy.milacares.com"
          className="hero-item__button button button--white"
        >
          Order Now
        </a>
      </div>
      <ImageLoader
        className="hero-item__image img-relative"
        placeholderAspectRatio={1320 / 617}
        image={slideMini}
        webp={slideMiniWebp}
        smallImage={slideMiniSm}
        smallWebp={slideMiniWebpSm}
        alt="The Mila air Sale"
        noLazyLoad
        fetchPriority="high"
        responsiveWidth={768}
      />
    </div>
  );
}

export default AirMiniSlide;
